// Base Contact Details Step
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import store from "../../veux/store";


let IndigenousStatus, Countries

// Base Contact Details Step Schema
let Base_Details_Step = {
    stepno: 2,
    title: 'Details',
    valid: true,
    information: '',
    Schema: {
        firstname: {
            type: 'text',
            label: 'First Name',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Firstname is Required')],
            class: 'mx-1 px-1',
            OUG: { Contacts: { Field: "firstname" } },
            onInput: (ev, portal) => {
                ev.data.firstname = functions.capitalizeFirstLetter(ev.data.firstname);
            }
        },
        surname: {
            type: 'text',
            label: 'Last Name',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Surname is Required')],
            class: 'mx-1 px-1',
            OUG: { Contacts: { Field: "surname" } },
            onInput: (ev, portal) => {
                ev.data.surname = functions.capitalizeFirstLetter(ev.data.surname);
            }
        },
        gender: {
            type: "select",
            label: "Gender",
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Gender is Required')],
            class: 'mx-1 px-1',
            items: rules.Gender,
            value: '',
            OUG: { Contacts: { Field: "gender" } }
        },
        DOB: {
            type: 'text',
            ext: 'date',
            locale: 'en',
            label: `Date of Birth (${store.getters.getdateFormat})`,
            outlined: true,
            dense: true,
            mask: store.getters.getdateMask,
            rules: [rules.requiredMsg('Date of Birth is Required')],
            class: 'mx-1 px-1',
            OUG: { Contacts: { Field: "date_of_birth" } }
        },
        email: {
            type: 'email',
            label: 'Email Address',
            outlined: true,
            dense: true,
            rules: [rules.validEmail, rules.requiredMsg('Email is Required')],
            class: 'mx-1 px-1',
            prependInnerIcon: 'alternate_email',
            toCtrl: ({ data }) => { return data.email },
            OUG: { Contact_Details: { Type: 3, Action: "Unique" } }
        },
        mobile: {
            type: 'tel',
            label: 'Mobile Number',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Mobile Number is Required')],
            mask: "####-###-###",
            class: 'mx-1 px-1',
            prependInnerIcon: 'phone',
            toCtrl: ({ data }) => { return data.mobile },
            OUG: { Contact_Details: { Type: 8, Action: "Unique" } }
        },
        Indigenous: {
            "type": "select",
            "label": "Aboriginal or Torres Strait Islander origin?",
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Aboriginal or Torres Strait Islander origin is Required')],
            class: 'mx-1 px-1',
            items: IndigenousStatus,
            value: '',
            OUG: { Contacts: { Field: "Indigenous" } }
        },
        photo: {
            type: 'file',
            label: 'Profile Picture',
            outlined: true,
            multiple: false,
            dense: true,
            accept: "image/*",
            rules: [rules.requiredMsg('Profile Picture is Required'), rules.fileSize()],
            class: 'mx-1 px-1',
            OUG: {
                Contact_Details: {
                    Type: 3367,
                    Action: "Unique",
                    Description: "Profile Picture"
                }
            }
        },
        emergencyName: {
            OUGid: 1172,
            type: 'text',
            label: 'Emergency Contact Name',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Emergency Contact Name is Required')],
            class: 'mx-1 px-1',
            toCtrl: ({ data }) => { return data.emergencyName },
            OUG: { Contact_Details: { Type: 1172, Action: "Unique" } },
            onInput: (ev, portal) => {
                ev.data.emergencyName = functions.capitalizeFirstLetter(ev.data.emergencyName);
            }
        },
        emergencyPhone: {
            OUGid: 1171,
            type: 'text',
            label: 'Emergency Contact Mobile',
            outlined: true,
            dense: true,
            mask: "####-###-###",
            rules: [rules.requiredMsg('Emergency Contact Mobile is Required')],
            class: 'mx-1 px-1',
            toCtrl: ({ data }) => { return data.emergencyPhone },
            OUG: { Contact_Details: { Type: 1171, Action: "Unique" } }
        },
        address: {
            type: 'text',
            label: 'Address Line 1',
            outlined: true,
            dense: true,
            prependInnerIcon: 'home',
            rules: [rules.requiredMsg('Address Line 1 is Required')],
            col: 12,
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.fulladdress = `${ev.data.address}, ${ev.data.city} ${ev.data.state} ${ev.data.pcode} ${ev.data.country}`
                ev.data.address = functions.capitalizeFirstLetter(ev.data.address);
            },
            toCtrl: ({ data }) => { return data.address }
        },
        city: {
            type: 'text',
            label: 'City',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('City is Required')],
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.fulladdress = `${ev.data.address}, ${ev.data.city} ${ev.data.state} ${ev.data.pcode} ${ev.data.country}`
                ev.data.city = functions.capitalizeFirstLetter(ev.data.city);
            }
        },
        state: {
            type: 'text',
            label: 'State / Province / Region',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('State / Province / Region is Required')],
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.fulladdress = `${ev.data.address}, ${ev.data.city} ${ev.data.state} ${ev.data.pcode} ${ev.data.country}`
                ev.data.state = ev.data.state.toUpperCase()
            }
        },
        pcode: {
            type: 'text',
            label: 'Postal / Zip Code',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Postal / Zip Code is Required')],
            class: 'mx-1 px-1',
            onInput: (ev, portal) => {
                ev.data.fulladdress = `${ev.data.address}, ${ev.data.city} ${ev.data.state} ${ev.data.pcode} ${ev.data.country}`
            }
        },
        country: {
            type: 'select',
            label: 'Country',
            outlined: true,
            dense: true,
            rules: [rules.requiredMsg('Country is Required')],
            class: 'mx-1 px-1',
            items: Countries,
            onInput: (ev, portal) => {
                ev.data.fulladdress = `${ev.data.address}, ${ev.data.city} ${ev.data.state} ${ev.data.pcode} ${ev.data.country}`
            }
        },
        fulladdress: {
            type: 'text',
            label: 'Address',
            outlined: true,
            dense: true,
            hidden: true,
            prependInnerIcon: 'home',
            rules: [],
            col: 12,
            class: 'mx-1 px-1',
            toCtrl: ({ data }) => { return data.fulladdress },
            OUG: { Contact_Details: { Type: 1, Action: "Unique" } }
        },
    },
    PreStep: (thisStep, portal) => {

        let { Model, Schema } = thisStep
        let currentUser = store.getters.currentUser,
            loggedIn = store.getters.loggedIn

        Schema.firstname.disabled = loggedIn
        Schema.surname.disabled = loggedIn
        Schema.DOB.disabled = loggedIn

        currentUser.EmailDetail ? portal.Model.email = currentUser.EmailDetail : null
        currentUser.PhoneDetail ? portal.Model.mobile = currentUser.PhoneDetail : null
        currentUser.GenderDetail ? portal.Model.gender = currentUser.GenderDetail : null
        currentUser.GenderDetail ? Schema.gender.value = currentUser.GenderDetail : null
        currentUser.Indigenous_Status ? portal.Model.Indigenous = currentUser.Indigenous_Status : null
        currentUser.Indigenous_Status ? Schema.Indigenous.value = currentUser.Indigenous_Status : null

        // store.getters.address ? home.data.Model.address = store.getters.address : null // Address Field
        store.getters.emergencyName ? portal.Model.emergencyName = store.getters.emergencyName : null
        store.getters.emergencyPhone ? portal.Model.emergencyPhone = store.getters.emergencyPhone : null

    },
}


export default {

    LoadSchema: async (Step) => {
        Base_Details_Step.stepno = Step
        Countries = await functions.GetCountries();
        IndigenousStatus = await functions.GetCodeBy({ Type: "Aboriginal Status" });
        Base_Details_Step.Schema.Indigenous.items = IndigenousStatus
        Base_Details_Step.Schema.country.items = Countries
        return Base_Details_Step
    },

}